<template>
    <div class="title">
        <h1> {{ $t('loginTitle') }} </h1>
        <el-card v-if="!message" v-loading="loading" class="form">
            <h2> {{ $t('resetPasswordMessage') }} </h2>
            <input-field
                :placeholder="$t('enterEmail')"
                :error="error"
                v-model="email"
            />
            <shared-buttons discardPath="Index" @confirm-event-fired="sendResetRequest(email)"></shared-buttons>
        </el-card>
        <p v-else>
            {{ message }}
            <a @click="$router.push({name: 'Index'})"> {{ $t('goBackMessage')}} </a>
        </p>
    </div>
</template>

<script>
import InputField from '@/components/Inputs/InputField'
import SharedButtons from '@/components/Shared/SharedButtons'
import api from '@/api/api'
export default {
    components: {
        InputField,
        SharedButtons
    },
    data () {
        return {
            email: '',
            error: '',
            loading: false,
            message: ''
        }
    },
    methods: {
        async sendResetRequest (email) {
            let response
            this.loading = true
            await api.resetPassword(email)
            .then((res) => {
                response = res
                console.log(response);
                
            })
            .catch((err) => {
                if (err.status === 422) {
                    err.data.message ? this.message = err.data.message : this.error = err.data.fields.email[0]
                } else {
                    this.message = this.$t('errorRequestMessage')
                }
                setTimeout(() => { 
                    this.loading = false
                }, 2000)                
            })
            if (response.status === 200 || response.status === 201) {
                setTimeout(() => { 
                    this.loading = false
                    this.message = this.$t('successRequestMessage')
                    // 'Request successfully sent!'
                }, 2000)
            }   
        }
    }
}
</script>

<style scoped>
    .title {
        text-align: center;
        margin-top: 36px;
    }

    .form {
        text-align: left;
        margin: 30px 100px;
        padding: 10px;
    }

    a {
        color: #409EFF;
        font-size: 12px;
        cursor: pointer;
    }

    h2 {
        text-align: center;
        font-weight: 200;
        /* padding-bottom: 30px; */
    }
</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordReset.vue